import React, { useState } from 'react'

import lang from 'lang'

import { ModalBig } from '@/modules/base/components/modal/index'
import IconCheck from '@assets/images/icons/check.svg'

import { makeStyles } from '@mui/styles'
import { PasswordInput } from '@/modules/base/components/inputs'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons/index'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
  },
  description: {
    paddingBottom: 20,
  },
}))

const PasswordPromptModal = (props) => {
  const { onAbort, onSubmit, dataQsId } = props
  const classes = useStyles()

  const [inputsValid, setInputsValid] = useState(false)
  const [password, setPassword] = useState('')

  const actions = [
    <CancelButton
      dataQsId={`${dataQsId}-cancel`}
      key='cancelBtn'
      label={lang.cancelButtonLabel}
      onClick={onAbort} />,
    <ButtonIconSquare
      dataQsId={`${dataQsId}-submit`}
      key='submitBtn'
      type='submit'
      icon={IconCheck}
      disabled={!inputsValid}
      onClick={() => onSubmit(password)}
      label={lang.loginButtonLabel} />,
  ]

  const onPasswordChange = (value) => {
    if (!inputsValid && value) setInputsValid(true)
    if (inputsValid && !value) setInputsValid(false)
    setPassword(value)
  }

  return (
    <ModalBig
      open={true}
      title={lang.modals.passwordPromptModal.title}
      actions={actions}
      onClose={onAbort}
      dataQsId={dataQsId}
    >
      <div className={classes.root}>
        <span className={classes.description}>{lang.modals.passwordPromptModal.description}</span>
        <PasswordInput
          dataQsId={`${dataQsId}-passwordInput`}
          withShowPassword
          value={password}
          key='passwordInput'
          name='password'
          label={lang.settings.user.password}
          onChange={onPasswordChange}
          required />
      </div>
    </ModalBig>
  )
}

PasswordPromptModal.protoTypes = {
  onAbort: PropTypes.func,
  onSubmit: PropTypes.func,
  dataQsId: PropTypes.string.isRequired,
}

export default PasswordPromptModal
